export default __webpack_public_path__ + "static/media/full-star.e85d4266e71d6f54398941365825b3ad.svg";